import {
  Directive,
  Input,
  Renderer2,
  OnChanges,
  SimpleChanges,
  HostListener,
  ElementRef
} from '@angular/core';
/**
 * This directive emulates hover functionality to be compliant
 * with Material Design Guidelines. An item should rise 8 points
 * of elevation when the cursor is over it (hover).
 *
 */
@Directive({
  selector: '[appHoverElevation]'
})
export class HoverElevationDirective implements OnChanges {
  // listens for a default elevation or sets it as 1 (lowest)
  @Input()
  defaultElevation = 1

  // listens for a hover Elevation or sets it as 9 (1 plus 8)
  @Input()
  hoverElevation = 9

  constructor(
    private element: ElementRef,
    private renderer: Renderer2
  ) {
    this.setElevation(this.defaultElevation)
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setElevation(this.defaultElevation)
  }

  // listens to the mouse over the element and switches to hoverElevation
  @HostListener('mouseenter')
  onMouseEnter() {
    this.setElevation(this.hoverElevation)
  }

  // listens to mouse leaving the element and returns to default elevation
  @HostListener('mouseleave')
  onmouseleave() {
    this.setElevation(this.defaultElevation)
  }

  /**
   * Sets the elevation of the element by the number informed by the element.
   * It can be hover elevation or the default elevation.
   */

  public setElevation(amount: number) {
    const removeOldElevation = Array.from(
      (this.element.nativeElement as HTMLElement).classList).filter(
        classes => classes.startsWith('mat-elevation-z')
      )
    removeOldElevation.forEach(elevation => {
      this.renderer.removeClass(this.element.nativeElement, elevation)
    })

    const addNewElevation = `mat-elevation-z${amount}`
    this.renderer.addClass(this.element.nativeElement, addNewElevation)
  }
}
